import type { DatadogDynamicConfig } from '@dn/libs/ui/dn-common';
import { DatadogEnvironment } from '@dn/libs/ui/dn-common';
import type { Environment } from '../environments/environment.interface';

export enum DatadogEnvironmentMapping {
    dev = DatadogEnvironment.DEV,
    staging = DatadogEnvironment.STAGING,
    prod = DatadogEnvironment.PRODUCTION,
}

// Factory function to get Datadog config
export function getDatadogConfig(appConfig: Environment): DatadogDynamicConfig {
  return {
    applicationId: '7577496d-d36e-4f48-89ff-4a34d1d30bd6',
    clientToken: 'puba1b4155e84b52a75acb8cfe33d9a6051',
    service: 'datanyze_platform',
    env: DatadogEnvironmentMapping[appConfig.name],
  };
}
